import React from "react";
import {Bling as GPT} from "react-gpt";

//GPT.enableSingleRequest();

export default class UseDfpSlot extends React.Component {
  constructor(props, context) {
    super(props, context);
  }
  render () {
    const {ads_width, ads_height} = this.props && this.props.datas ? this.props.datas : {ads_width:300, ads_height:250} 
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    return (
      <div id={Math.random()}>
        {vw >= 750 ?
            <div>
              <GPT
                adUnitPath={this.props.datas && this.props.datas.ads_path ? this.props.datas.ads_path : "/1027941/cincysavers_728x90"}
                slotSize={[parseInt(ads_width), parseInt(ads_height)]}
              />
            </div>
          :
            <div>
              <GPT
                adUnitPath={this.props.datas && this.props.datas.ads_path ? this.props.datas.ads_path : "/1027941/cincysavers_728x90"}
                slotSize={[320, 50]}
              />
            </div>
        }  
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/UseDfpSlot.js